import { axiosPrivate } from 'shared/api';
import { ISector } from 'features/settings/topology/types';
import { ExportableResourceService } from 'shared/services/ExportableResourceService';

class CategoryService extends ExportableResourceService<ISector> {
  constructor() {
    super('categories');
  }
  canDelete = true;

  importFromFile = async (importFile: File, attachmentName = 'import_file') => {
    const res = await axiosPrivate.postForm(`${this.modulePrefix}/import-from-file/`, {
      [attachmentName]: importFile
    });
    return res.data;
  };
}

export const categoryService = new CategoryService();
